import React, { useState , useContext, useEffect } from "react";
import app from "../base";
import { withRouter } from "react-router-dom";
import { AuthContext } from "../Auth";
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Logo from "../images/logo text.png" 
import hos1 from "../images/hos1.jpg"
import hos2 from "../images/hos2.png"
import hos3 from "../images/hos3.png"
import hos4 from "../images/hos4.jpg"
import hos5 from "../images/hos5.jpg"
import hos6 from "../images/hos6.png"
import hos7 from "../images/hos7.png"
import hos8 from "../images/hos8.jpg"
import hos9 from "../images/hos9.jpg"
import hos10 from "../images/hos10.png"
import hos11 from "../images/hos11.jpg"
import hos12 from "../images/hos12.png"
import hos13 from "../images/hos13.jpg"
import hos14 from "../images/hos14.jpg"
import hos15 from "../images/hos15.jpg"
import hos16 from "../images/hos16.png"
import hos17 from "../images/hos17.png"
import hos18 from "../images/hos18.png"
import hos19 from "../images/hos19.png"
import hos20 from "../images/hos20.jpg"
import hos21 from "../images/hos21.jpg"
import hos22 from "../images/hos22.jpg"
import hos23 from "../images/hos23.png"
import hos24 from "../images/hos24.jpg"
import hos25 from "../images/hos25.jpg"
import hos26 from "../images/hos26.jpg"
import hos27 from "../images/hos27.png"
import hos28 from "../images/hos28.jpg"
import hos29 from "../images/hos29.jpg"
import hos30 from "../images/hos30.jpg"
import hos31 from "../images/hos31.png"
import hos32 from "../images/hos32.jpg"
import hos33 from "../images/hos33.jpg"
import hos34 from "../images/hos34.jpg"
import hos35 from "../images/hos35.jpg"
import hos36 from "../images/hos36.png"
import hos37 from "../images/hos37.jpeg"
import hos38 from "../images/hos38.jpg"



const T7 = ({history}) => {
  const { currentUser } = useContext(AuthContext);
  const [file, setFile] = useState(null);
  const [base64, setBase64] = useState(null);
  

  const Signout = () => {
    app.auth().signOut();
    history.push("/");
    window.location.reload(true)
  };


  return (
    <>
    <Navbar className="navbar fixed-top navbar-light" expand="lg">
      <Container className="container">
      <Navbar.Brand className="navbar-brand logo-image" href="/">
        <img src= {Logo} />
      </Navbar.Brand>
      <Navbar.Toggle
        className="navbar-toggler p-0 border-0 ml-auto mr-3"
        type="button"
        data-toggle="offcanvas"
        aria-controls="basic-navbar-nav"
      />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="navbar-nav ml-auto">
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/">
              บริการ <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/">
              ข่าวสารจาก EIPCA <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/about">
              เกี่ยวกับเรา
            </Nav.Link>
          </li>
        </center>
        <center>
            <li className="nav-item">
            <Nav.Link class="nav-link" style={{color: "red"}} href="#" onClick={Signout} >ออกจากระบบ</Nav.Link>
            </li>
        </center>
        <center>
          <li className="nav-item">
            <a className= "mx-3" href="/HardwareHistory">
              <img style={{width: "40px", height: "40px"}} src= "https://cdn-icons-png.flaticon.com/512/6522/6522516.png"  />
          </a>
          </li>
        </center>
         
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>


    <br/>
  <br/>
  <br/>
  <br/>
  <div className="app container p-5">
      <h1 className="text-center mb-2">ตารางออกตรวจแพทย์</h1>
      <Table className="table table-hover table-bordered p-5 text-center ">
      <thead>
        <tr>
          <th>วัน</th>
          <th>เวลา</th>
          <th>สถานที่</th>
          
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>จันทร์</td>
          <td>17:00 - 20:00</td>
          <td>ศูนย์โรคหัวใจ ชั้น 9 อาคารเฉลิมพระเกียรติฯ</td>
        </tr>
        
      </tbody>
    </Table>
        <p>ตารางออกตรวจอาจมีการเเปลี่ยนแปลง สอบถามเพิ่มเติมได้ที่ 053-936900 , 053-936901 , 065-4724657 , 065-4724658</p>
       </div>
  

      
    </>
  );
};

export default withRouter(T7);